import { gql } from '@apollo/client';
// Fragments
import {
  HostedTicketEventFields,
  TicketHoldFields,
  TicketOrderFields,
} from './fragments';

export const CREATE_TICKET_EVENT = gql`
  mutation CreateTicketEvent($input: CreateTicketEventInput!) {
    createTicketEvent(input: $input) {
      id
      version
    }
  }
`;

export const CREATE_TICKET_EVENT_IMAGE_UPLOAD_URLS = gql`
  mutation CreateTicketEventImageUploadUrls(
    $input: TicketEventImageUploadInput!
  ) {
    createTicketEventImageUploadUrls(input: $input) {
      url
      fields
      key
    }
  }
`;

export const APPROVE_TICKET_ZERO_TAX = gql`
  mutation ApproveTicketZeroTax($input: ApproveTicketZeroTaxInput!) {
    approveTicketZeroTax(input: $input) {
      id
      version
    }
  }
`;

export const SET_TICKET_SALE_STATUS = gql`
  mutation SetTicketSaleStatus($input: SetTicketSaleStatusInput!) {
    setTicketSaleStatus(input: $input) {
      ...HostedTicketEventFields
    }
  }
  ${HostedTicketEventFields}
`;

export const CREATE_TICKET_HOLD = gql`
  mutation CreateTicketHold($input: CreateTicketHoldInput!) {
    createTicketHold(input: $input) {
      ...TicketHoldFields
    }
  }
  ${TicketHoldFields}
`;

export const APPLY_TICKET_HOLD_PROMOCODE = gql`
  mutation ApplyTicketHoldPromocode($input: ApplyTicketHoldPromocodeInput!) {
    applyTicketHoldPromocode(input: $input) {
      ...TicketHoldFields
    }
  }
  ${TicketHoldFields}
`;

export const CHECKOUT_TICKET_ORDER = gql`
  mutation CheckoutTicketOrder($input: CheckoutTicketOrderInput!) {
    checkoutTicketOrder(input: $input) {
      ...TicketOrderFields
    }
  }
  ${TicketOrderFields}
`;

export const UPDATE_TICKET_EVENT_DETAILS = gql`
  mutation UpdateTicketEventDetails($input: UpdateTicketEventDetailsInput!) {
    updateTicketEventDetails(input: $input) {
      ...HostedTicketEventFields
    }
  }
  ${HostedTicketEventFields}
`;

export const RESCHEDULE_TICKET_EVENT = gql`
  mutation RescheduleTicketEvent($input: RescheduleTicketEventInput!) {
    rescheduleTicketEvent(input: $input) {
      ...HostedTicketEventFields
    }
  }
  ${HostedTicketEventFields}
`;

export const UPDATE_TICKET_VENUE = gql`
  mutation UpdateTicketVenue($input: UpdateTicketVenueInput!) {
    updateTicketVenue(input: $input) {
      id
      version
      status
      startsAt
    }
  }
`;

export const ADD_TICKET_TIER = gql`
  mutation AddTicketTier($input: AddTicketTierInput!) {
    addTicketTier(input: $input) {
      id
    }
  }
`;

export const SET_TICKET_EVENT_MATCHUPS = gql`
  mutation SetTicketEventMatchups($input: SetTicketEventMatchupsInput!) {
    setTicketEventMatchups(input: $input) {
      id
    }
  }
`;

export const ACCEPT_TICKET_TRANSFER = gql`
  mutation AcceptTicketTransfer($input: AcceptTicketTransferInput!) {
    acceptTicketTransfer(input: $input) {
      id
    }
  }
`;

export const TRANSFER_TICKET = gql`
  mutation TransferTicket($input: TransferTicketInput!) {
    transferTicket(input: $input) {
      id
      status
      recipientEmail
      expiresAt
    }
  }
`;

export const CANCEL_TICKET_TRANSFER = gql`
  mutation CancelTicketTransfer($input: CancelTicketTransferInput!) {
    cancelTicketTransfer(input: $input) {
      id
      status
    }
  }
`;
